export { default } from "./Historiales";
